import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Table } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';

const Tender = () => {
  const navigate = useNavigate();
  const [tender, setTender] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError(null);
        setLoading(true);
        const tenderId = window.location.href.split('/').pop();
        if (tenderId) {
          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/tenders/id/${tenderId}`
          );
          if (response.data.length > 0) {
            if (response.data[0].description) {
              response.data[0].description = response.data[0].description.replace(/\n/g, '<br/>');
            }
            setTender(response.data[0]);
          }
        } else {
          navigate('/tenders/list');
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <PageHeader
        title='Tender details'
        description=''
        className='mb-3'
      ></PageHeader>
      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div>Error: {error}</div>
      ) : tender?.id ? (
        <Table hover responsive>
          <tbody>
            <tr>
              <td>Name: {tender.name}</td>
            </tr>
            <tr>
              <td>Date Added: {tender.date_added}</td>
            </tr>
            <tr>
              <td>Closing Date: {tender.closing_date}</td>
            </tr>
            <tr>
              <td>Contact: {tender.contact}</td>
            </tr>
            <tr>
              <td>Email: {tender.email}</td>
            </tr>
            <tr>
              <td>Description:
                <div
                  className='news-body'
                  dangerouslySetInnerHTML={{ __html: tender.description }}
                ></div>
              </td>
            </tr>
            <tr>
              <td>Tel: {tender.tel}</td>
            </tr>
            <tr>
              <td>Reference: {tender.reference}</td>
            </tr>
            <tr>
              <td>Status: {tender.status}</td>
            </tr>
            <tr>
              <td>Fee: {tender.fee}</td>
            </tr>
            <tr>
              <td>Hits: {tender.hits}</td>
            </tr>
            <tr>
              <td>Attachment: <a href={tender.attachment} target="_blank" rel="noreferrer" >Open PDF</a></td>
            </tr>
            <tr>
              <td>Attachment Awarded: <a href={tender.attachment_awarded} target="_blank" rel="noreferrer" >Open PDF</a></td>
            </tr>
          </tbody>
        </Table>
      ) : (
        <div>Tender not found</div>
      )}
    </>
  );
};

export default Tender;